var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93066 2.44376V9.01071C5.93066 13.7426 9.71552 17.6649 14.4473 17.6999C15.5797 17.7085 16.7027 17.4929 17.7513 17.0655C18.8 16.6381 19.7538 16.0073 20.5575 15.2096C21.3613 14.4119 21.9993 13.463 22.4346 12.4176C22.87 11.3721 23.0941 10.2509 23.0941 9.11844V2.44376C23.0941 2.19087 22.9937 1.94834 22.8148 1.76952C22.636 1.5907 22.3935 1.49023 22.1406 1.49023H6.88419C6.6313 1.49023 6.38877 1.5907 6.20995 1.76952C6.03112 1.94834 5.93066 2.19087 5.93066 2.44376Z",
    stroke: "#1E8067",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6992 22.4678H18.3274",
    stroke: "#1E8067",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5127 17.7002V22.4678",
    stroke: "#1E8067",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8818 11.0253H24.048C25.0596 11.0253 26.0297 10.6234 26.745 9.90814C27.4603 9.19286 27.8621 8.22273 27.8621 7.21116V5.30411C27.8621 5.05122 27.7617 4.80869 27.5829 4.62987C27.404 4.45105 27.1615 4.35059 26.9086 4.35059H23.0945",
    stroke: "#1E8067",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16335 11.0253H4.96059C3.94902 11.0253 2.97889 10.6234 2.26361 9.90814C1.54833 9.19286 1.14648 8.22273 1.14648 7.21116V5.30411C1.14648 5.05122 1.24694 4.80869 1.42577 4.62987C1.60459 4.45105 1.84712 4.35059 2.10001 4.35059H5.91411",
    stroke: "#1E8067",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.7cecfc85c186b3b27960a30f65905a1d.svg";
export { ForwardRef as ReactComponent };